export default __webpack_public_path__ + "assets/4bb19361269718156dab9f81b1f939e9.woff";